<template>
  <div class="ddqr-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="核对情况">
              <el-select v-model="searchForm.chk" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="未核对" :value="0" />
                <el-option label="已核对" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.order_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="110"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.brand_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="预计完成时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.preSplit || '--' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单完成时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.split_time || '--' }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    label="拆单时长"
                    width="220"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <div class="view-info">
                        <div class="tit">
                          拆单耗时：
                          <span v-if="scope.row.splitTake" style="color: #409EFF;">{{ tranfromSec(scope.row.splitTake) }}</span>
                          <span v-else>--</span>
                        </div>
                        <div class="tit">
                          暂停时长：
                          <span v-if="scope.row.splitPauseTake" style="color: #E6A23C;">{{ tranfromSec(scope.row.splitPauseTake) }}</span>
                          <span v-else>--</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单员"
                    width="110"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.splitname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="核对情况"
                    width="80"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.chk==0" :disable-transitions="true" size="mini" type="warning">未核对</el-tag>
                      <el-tag v-if="scope.row.chk==1" :disable-transitions="true" size="mini">已核对</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    label="拆单状态"
                    width="100"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.splitStatus===0" :disable-transitions="true" size="mini" type="warning">未开始</el-tag>
                      <el-tag v-if="scope.row.splitStatus===1" :disable-transitions="true" size="mini" type="primary">进行中</el-tag>
                      <el-tag v-if="scope.row.splitStatus===2" :disable-transitions="true" size="mini" type="danger">已暂停</el-tag>
                      <el-tag v-if="scope.row.splitStatus===3" :disable-transitions="true" size="mini" type="warning">待拆单员确认</el-tag>
                      <el-tag v-if="scope.row.splitStatus===4" :disable-transitions="true" size="mini" type="success">已完成</el-tag>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    width="220"
                    align="left"
                    fixed="right"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document-checked" @click.stop="affirm(scope.row)">拆单审核</el-button>
                      <el-button v-if="scope.row.chk == 0" plain size="mini" icon="el-icon-check" type="success" @click.stop="check(scope.row)">核对</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="拆单审核"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆单详情" prop="spitdetail">
          <el-card shadow="hover" style="font-size: 12px">
            <div>
              <span style="color:#99a9bf">拆单人员：</span>
              <span style="color:#606266">{{ editForm.splitname }}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单时间：</span>
              <span style="color:#606266">{{ editForm.splittime }}</span>
            </div>
            <div>
              <span style="color:#99a9bf">拆单结果：</span>
              <span><el-button type="text" icon="el-icon-document" title="点击查看拆单详情" @click="getMaterialDetail">{{ editForm.splitfile }}</el-button></span>
              <el-divider direction="vertical"></el-divider>
              <span><el-button type="text" icon="el-icon-download" @click="downMaterial">下载生产料单</el-button></span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="审单备注" prop="content">
          <el-input v-model="editForm.content" type="textarea" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">立即确认</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单拆单详情"
      :visible.sync="materialVisible"
      top="10vh"
      :fullscreen="true"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true"
    >
      <div v-loading="materialloading" :style="'height:'+divHeight+'px ;width: 100%'">
        <el-container>
          <el-header height="30px">
            <div style="font-size: 14px;">
              <span style="margin-right: 20px;color: #99a9bf;">客户：<span style="color:#606266;">{{ editRow.all_name }}</span></span>
              <span style="margin-right: 20px;color: #99a9bf;">单号：<span style="color:#606266;">{{ editRow.order_num }}</span></span>
              <span v-if="editRow.product_num===''||editRow.product_num===null" style="margin-right: 20px;color: #99a9bf;">生产单号：<span style="color:#606266;">N/A</span></span>
              <span v-if="editRow.product_num!==''&&editRow.product_num!==null" style="margin-right: 20px;color: #99a9bf;">生产单号：<span style="color:#606266;">{{ editRow.product_num }}</span></span>
              <span style="margin-right: 20px;color: #99a9bf;">拆单人员：<span style="color:#606266;">{{ editRow.splitname }}</span></span>
              <span style="margin-right: 20px;color: #99a9bf;">终端地址：<span style="color:#606266;">{{ editRow.address }}</span></span>
              <span style="margin-right: 20px;color: #99a9bf;">拆单日期：<span style="color:#606266;">{{ editRow.split_time }}</span></span>
            </div>
          </el-header>
          <el-main :style="'height:'+(divHeight-30)+'px ;width: 100%'">
            <pl-table
              :height="(divHeight-70)+'px'"
              :datas="materialTableData"
              :data="materialTableData"
              border
              size="small"
              use-virtual
              :pagination-show="false"
              :thtd-beyond-hiding="false"
              :default-expand-all="true"
              :row-height="45"
            >
              <pl-table-column prop="xuhao" label="序号" width="80"></pl-table-column>
              <pl-table-column prop="area" label="区域" width="120"></pl-table-column>
              <pl-table-column prop="type" label="分类" width="80"></pl-table-column>
              <pl-table-column prop="name" label="名称" width="160"></pl-table-column>
              <pl-table-column prop="material" label="基材" width="80"></pl-table-column>
              <pl-table-column prop="high" label="高/长" width="70"></pl-table-column>
              <pl-table-column prop="width" label="宽" width="70"></pl-table-column>
              <pl-table-column prop="lwidth" label="L宽" width="70"></pl-table-column>
              <pl-table-column prop="ply" label="厚" width="70"></pl-table-column>
              <pl-table-column prop="num" label="数量" width="70"></pl-table-column>
              <pl-table-column prop="val" label="数值" width="70"></pl-table-column>
              <pl-table-column prop="unit" label="单位" width="70"></pl-table-column>
              <pl-table-column prop="color" label="颜色" width="140"></pl-table-column>
              <pl-table-column prop="remark" label="备注" min-width="160"></pl-table-column>
            </pl-table>
          </el-main>
        </el-container>
      </div>
      <!--      <div slot="footer" class="dialog-footer">-->
      <!--        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, reviewOrder, getErpOrderMaterialDetail, chkOrder } from '@/api/erp'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { getBrandList } from '@/api/work'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'Sd',
  components: {
    MultiFile,
    MultiImg
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      materialVisible: false,
      materialloading: false,
      materialTableData: [],
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: [],
        splitname: '',
        splittime: '',
        splitfile: '',
        splitfileid: ''
      },
      editRow: {},
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      divHeight: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    tranfromSec(seconds) {
      if (!seconds || seconds <= 0) return '--'
      const d = parseInt(seconds/60/60/24)
      const h = parseInt(seconds/60/60%24)
      const m = parseInt(seconds/60%60)
      const s = parseInt(seconds%60)
      return (d > 0 ? d + '天' : '') + (h > 0 ? h + '小时' : '') + (m > 0 ? m + '分' : '') + s + '秒'
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        mark: 6,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId,
        chk: this.searchForm.chk,
        issd: 1
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    downMaterial() {
      getFileInfo({ fileid: this.editForm.splitfileid }).then(response => {
        /* this.$message({
          message: '生产料单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.divHeight = document.body.offsetHeight - 75
      this.materialVisible = true
      this.materialloading = true
      getErpOrderMaterialDetail({ orderid: this.editForm.orderid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
      }).catch(() => {
        this.materialloading = false
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        let tempindex = 0
        let rowspan = 1
        let temp = null
        for (let i = 0; i <= this.materialTableData.length; i++) {
          if (i === 0) {
            tempindex = i
            rowspan = 1
            temp = this.materialTableData[i].area
          } else {
            if (i === this.materialTableData.length) {
              if (rowIndex === tempindex) {
                return {
                  rowspan: rowspan,
                  colspan: 1
                }
              }
            } else {
              if (temp === this.materialTableData[i].area) {
                rowspan++
                if (rowIndex === i) {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              } else {
                if (rowIndex === tempindex) {
                  return {
                    rowspan: rowspan,
                    colspan: 1
                  }
                } else {
                  tempindex = i
                  rowspan = 1
                  temp = this.materialTableData[i].area
                }
              }
            }
          }
        }
      }
    },
    // 核对
    check(row) {
      this.$confirm('是否确认已核对订单 ' + row.order_num + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          orderid: row.order_id
        }
        chkOrder(data).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    affirm(row) {
      this.editRules.content[0].required = false
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.splitname = row.splitname
      this.editForm.splittime = row.split_time
      this.editForm.splitfile = row.split_filename
      this.editForm.splitfileid = row.split_fileid
      this.editRow = row
      this.editVisible = true
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAffirmOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAffirmOrder(1)
        } else {
          return false
        }
      })
    },
    SubAffirmOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          reason: this.editForm.content,
          ispass: ispass,
          fileStr: this.editForm.files.join(','),
          imgStr: this.editForm.imgids.join(',')
        }
        reviewOrder(data).then(response => {
          let msg = '审单已确认'
          if (ispass === 0) {
            msg = '审单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ddqr-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}

.view-info {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .tit {
    color: #606266;
    display: flex;

    span {
      font-weight: bold;
    }
  }
}
</style>
